import React, { useState } from "react";
import { Tenant } from "../Types";

interface TenantCardProps extends Tenant {
  checkList: Array<Tenant>;
  setCheckList: React.Dispatch<React.SetStateAction<Tenant[]>>
}

const TenantSelectionCard = ({ checkList, setCheckList, ...tenant }: TenantCardProps) => {

  const {description, id, image, name} = tenant;


  const [isSelected, setIsSelected] = useState(checkList.some((item) => item.id === id))

  return (
    <div
      className={`ohtcard ${isSelected ? "ohtcard--selected" : ""}`}
      onClick={() => {
        const isAlreadySelected = checkList.some(item => item.id === tenant.id);

        if(checkList.some((item) => item.id === tenant.id)) {
          setCheckList(checkList.filter((item) => item.id !== id))
          setIsSelected(false);
        }
        else if(checkList.length >= 10){
          
        }
        else {
          setCheckList([...checkList, tenant ])
          setIsSelected(true);
        }
      }}
    >
      <img src={image} alt={description} className="ohtcard__image" />
      <div className="ohtcard__textcontainer">
        <p className="ohtcard__name">{name}</p>
        <p className="ohtcard__description">{description}</p>
      </div>
    </div>
  );
};

export default TenantSelectionCard;
